import type { MessageResponse, NotificationSettings, NotificationsListResponse, RequestOptions, UnreadNotificationsResponse } from '@cravo/core'
import { api } from '../api-client'

export const notificationsApi = {
  list(params?: { limit?: number; cursor?: string }, options?: RequestOptions): Promise<NotificationsListResponse> {
    return api.get<NotificationsListResponse>('/notifications', {
      ...options,
      params: {
        limit: params?.limit,
        cursor: params?.cursor,
        ...options?.params,
      },
    })
  },

  getUnreadCount(options?: RequestOptions): Promise<UnreadNotificationsResponse> {
    return api.get<UnreadNotificationsResponse>('/notifications/unread-count', options)
  },

  getSettings(options?: RequestOptions): Promise<NotificationSettings> {
    return api.get<NotificationSettings>('/notifications/settings', options)
  },

  updateSettings(data: Partial<NotificationSettings>, options?: RequestOptions): Promise<NotificationSettings> {
    return api.patch<NotificationSettings>('/notifications/settings', data, options)
  },

  markAsRead(ids?: string[], options?: RequestOptions): Promise<MessageResponse> {
    return api.patch<MessageResponse>('/notifications/read', ids?.length ? { ids } : {}, options)
  },

  delete(ids: string[], options?: RequestOptions): Promise<MessageResponse> {
    return api.delete<MessageResponse>('/notifications', {
      ...options,
      data: { ids },
    })
  },
}
